import { Box } from '@/shared/ui';

import type { SavedFilter, SavedFilterCriteria } from '@/entities/saved-filter';

import SavedFilterRow from './SavedFilterRow';

const sectionSx = {
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'gx.tileLight'
};

interface SavedFiltersListProps {
  savedFilters: SavedFilter[];
  onApply: (criteria: SavedFilterCriteria) => void;
  onDelete: (id: string) => void;
}

const SavedFiltersList = ({ savedFilters, onApply, onDelete }: SavedFiltersListProps) => {
  if (savedFilters.length === 0) return null;

  return (
    <Box sx={sectionSx}>
      <Box
        sx={{
          color: '#6D737A',
          fontSize: '10px',
          fontWeight: 700,
          borderBottom: '0.5px solid',
          borderBottomColor: 'gx.response',
          px: 1.5,
          py: 1
        }}
      >
        SAVED FILTERS
      </Box>
      {savedFilters.map(filter => (
        <SavedFilterRow
          key={filter.id}
          filter={filter}
          onApply={onApply}
          onDelete={onDelete}
        />
      ))}
    </Box>
  );
};

export default SavedFiltersList;
